import { useEffect, useState } from "react"
import type { CombinedError, UseQueryExecute } from "urql"
import { useQuery } from "urql"

import type { ProductShelvingRequirement } from "../types"

import type { Query } from "@/graphql/codegen/graphql"
import { GetProductShelvingRequirementDocument } from "@/graphql/codegen/graphql"

export interface UseGetProductShelvingRequirementReturn {
  shelvingRequirement: ProductShelvingRequirement | null
  isFetching: boolean
  error?: CombinedError
  refetch: UseQueryExecute
}

export const useGetProductShelvingRequirement = (productId: number): UseGetProductShelvingRequirementReturn => {
  const [shelvingRequirement, setShelvingRequirement] = useState<ProductShelvingRequirement | null>(null)
  const [{ data, fetching, error }, reexecuteQuery] = useQuery<Pick<Query, "productShelvingRequirement">>({
    query: GetProductShelvingRequirementDocument,
    variables: { productId },
  })

  useEffect(() => {
    const productShelvingRequirement = data?.productShelvingRequirement.get
    if (
      !(
        productShelvingRequirement?.coldStorage ||
        productShelvingRequirement?.h3ColdStorage ||
        productShelvingRequirement?.binSize ||
        productShelvingRequirement?.deep ||
        productShelvingRequirement?.stackable
      )
    )
      return

    setShelvingRequirement(productShelvingRequirement as ProductShelvingRequirement)
  }, [data])

  return {
    shelvingRequirement,
    isFetching: fetching,
    error,
    refetch: reexecuteQuery,
  }
}
